import 'devextreme/dist/css/dx.common.css';
import 'devextreme/dist/css/dx.light.css';

import vueBaseApp from '@entro-no/common/vue/vue.base.app';
import App from './App.vue'

const options = {
  config: {
    appId: 0,
    sentryDsnCode: 'https://3e9d5d33748c459abed81337454498b6@sentry.io/1407407'
  }
};

vueBaseApp.init(App, options);
